import * as React from 'react';
import { Dispatch, connect } from 'react-redux';
import { ITicketingState, IApplicationState, AppActionCreators, ICenterState, IIncidentReportResponse, DashActionCreators } from '@nkr/store/index';
import { IIncidentReportRequest, IIncidentReport } from '@nkr/models/index';
import ReactHtmlParser from 'react-html-parser';
import { Button, Panel, ControlLabel, Label } from 'react-bootstrap';
import { toast } from 'react-toastify';

interface IProps { incidentReportId: number }

interface IStateProps {
    ticketing: ITicketingState,
    centers: ICenterState
}

interface IDispatchProps {
    showLoading: (message: string) => Promise<void>,
    hideLoading: () => void,
    getIncidentReportDetails: (incidentReportId) => Promise<IIncidentReportResponse>,
    saveIncidentReport: (incidentReport: IIncidentReportRequest) => Promise<IIncidentReportResponse>,
}

type TProps = IProps & IStateProps & IDispatchProps;


interface IState {
    incidentReportDetailData: IIncidentReport,
    minHeight: number
}

class IncidentReportDetails extends React.Component<TProps, IState> {
    readonly state: IState = {
        incidentReportDetailData: null,
        minHeight: 400
    }

    componentDidMount = () => {
        this.getData();
    }

    handleMarkReviewed = (statusType: number) => {
        let { id,
            centerId,
            incidentOriginTypeId,
            incidentDate,
            centerDisplayUserId,
            donorConnectGroup,
            description,
            candidateFirstName,
            candidateLastName,
            incidentCategoryTypeId,
            assignedMentorId,
        } = this.state.incidentReportDetailData;

        let request: IIncidentReportRequest = {
            id,
            centerId,
            incidentOriginTypeId,
            incidentStatusId: statusType,
            incidentDate,
            description,
            centerDisplayUserId,
            donorConnectGroup,
            candidateFirstName,
            candidateLastName,
            incidentCategoryTypeId,
            assignedMentorId,
        };

        this.props.showLoading('Updating incident report, one moment please...').then(() => {
            this.props.saveIncidentReport(request).then((response) => {
                if (response.data.success) {
                    toast.success('Successfully reviewed the incident report');
                }

                this.props.hideLoading();
            });
        });
    }

    getData = () => {
        this.props.showLoading('Loading incident reports, one moment please...').then(() => {
            return Promise.all([
                this.props.getIncidentReportDetails(this.props.incidentReportId),
            ]).then(([reportListResponse]) => {
                if (reportListResponse.data.success) {

                    let incidentReportDetailData = reportListResponse.data.results;

                    this.setState({
                        incidentReportDetailData
                    });
                }

                this.props.hideLoading();
            });
        });
    }

    render = () => {
        if (this.state.incidentReportDetailData == null)
            return null;

        const content = this.state.incidentReportDetailData.description.replace(/[\n\r]/g, '<br/>');

        return (
            <div style={{ backgroundColor: 'white', height: '75vh' }}>
                <div className='container'>
                    <h1>Incident Report Details </h1>

                    <Panel>
                        <Panel.Heading>
                            <div className='row'>
                                <div className='col-xs-2'>
                                    <ControlLabel>Date Created:</ControlLabel>
                                </div>
                                <div className='col-xs-5'>
                                    {this.state.incidentReportDetailData.incidentDate}
                                </div>
                            </div>

                            <div className='row'>
                                <div className='col-xs-2'>
                                    <ControlLabel>Incident Type:</ControlLabel>
                                </div>
                                <div className='col-xs-5'>
                                    {this.state.incidentReportDetailData.incidentStatus}
                                </div>
                            </div>

                            <div className='row'>
                                <div className='col-xs-2'>
                                    <ControlLabel>Reported By:</ControlLabel>&nbsp;
                                </div>
                                <div className='col-xs-5'>
                                    {this.state.incidentReportDetailData.centerDisplayUserName}
                                </div>
                            </div>
                        </Panel.Heading>

                        <Panel.Body>
                            <div>{ReactHtmlParser(content)}</div>
                        </Panel.Body>

                        <Panel.Footer>
                            <div className='text-right'>
                                {this.state.incidentReportDetailData.incidentStatusId == 3 ?
                                    <Label bsStyle='success' style={{ fontSize: '100%' }}> Incident was reviewed</Label>
                                    :
                                    <Button bsStyle='primary' onClick={() => this.handleMarkReviewed(3)}>Mark as Reviewed</Button>
                                }
                            </div>
                        </Panel.Footer>
                    </Panel>
                </div>
            </div>
        );
    }
}

const mapStateToProps = (state: IApplicationState): IStateProps => {
    return {
        ticketing: state.ticketing,
        centers: state.centers
    };
}

const mapDispatchToProps = (dispatch: Dispatch<IApplicationState>): IDispatchProps => {
    return {
        showLoading: (message) => {
            return dispatch(AppActionCreators.showLoadingAsync(message));
        },
        hideLoading: () => {
            return dispatch(AppActionCreators.hideLoading());
        },
        getIncidentReportDetails: (incidentReportId) => {
            return dispatch(DashActionCreators.getIncidentReportDetails(incidentReportId));
        },
        saveIncidentReport: (incidentReport) => {
            return dispatch(DashActionCreators.saveIncidentReport(incidentReport));
        },
    };
}

export default connect<IStateProps, IDispatchProps, IProps>(
    mapStateToProps,
    mapDispatchToProps)(IncidentReportDetails);
